// import page from 'page';
import router from '../../lib/router';
import ResetPassword from '../../auth/ResetPassword.svelte';
import ShareOrder from '../../orders/shareOrder/ShareOrder.svelte';
import PublicWorkersMap from '../../workers-map/PublicWorkersMap.svelte';
import WorkerPublicCV from '../../cv/WorkerPublicCV.svelte';
import AuthPage from '../../auth/AuthPage.svelte';
import WP from '../state-store';

const local_route_map = {
  '/login': {
    component: AuthPage,
    props: {
      query: null,
    },
  },
  '/reset-password': {
    component: ResetPassword,
    props: {
      query: null,
    },
  },
};

const render_page = context => {
  let path = context.path;
  let target = document.querySelector('#application');
  let isCypress = document.querySelector('.aut-iframe');

  if (isCypress) {
    target = top.document
      .querySelector('.aut-iframe')
      .contentDocument.querySelector('#application');
  }

  return render_local_page(target, path, context);
};

const render = (component, options) => {
  if (
    WP.current_view &&
    WP.current_view.$$ &&
    WP.current_view.$$.on_destroy &&
    Array.isArray(WP.current_view.$$.on_destroy)
  ) {
    WP.current_view.$$.on_destroy.map(f => f());
  }
  WP.current_view = new component(options);
};

const render_local_page = (target, path, context) => {
  const current = local_route_map[path];

  if (!current) return render_local_page(target, '/login', context);

  target.innerHTML = '';
  if (context.query && current.props.query !== undefined) {
    current.props.query = context.query;
  }

  render(current.component, {
    target: target,
    props: current.props,
  });
};

const render_public_cv_page = context => {
  let target = top.document.querySelector('#application');

  target.innerHTML = '';

  render(WorkerPublicCV, {
    target: target,
    props: {
      route_name: '/cv',
      worker_uuid: context.params.worker_uuid,
    },
  });
};

const render_public_workers_map = context => {
  let target = top.document.querySelector('#application');

  target.innerHTML = '';

  render(PublicWorkersMap, {
    target: target,
    props: {
      merchant_uuid: context.params.merchant_uuid,
    },
  });
};

const render_shared_order = context => {
  let target = top.document.querySelector('#application');

  target.innerHTML = '';

  render(ShareOrder, {
    target: target,
    props: {
      order_uuid: context.params.order_uuid,
      query: { id: context.params.order_uuid },
    },
  });
};

const confirm_email = context => {
  let target = top.document.querySelector('#application');

  target.innerHTML = '';

  render(AuthPage, {
    target: target,
    props: {
      query: { confirmation_code: context.query.code },
    },
  });
};

export const init_router = () => {
  router.add_routes([
    { path: '/confirm', view: confirm_email },
    { path: '/cv/worker/:worker_uuid', view: render_public_cv_page },
    { path: '/order/share/:order_uuid', view: render_shared_order },
    { path: '/order/shared/:order_uuid', view: render_shared_order },
    {
      path: '/workers_map/service/:merchant_uuid',
      view: render_public_workers_map,
    },
    { path: '/(.*)', view: render_page },
  ]);

  router.start();
};

export const Router = {
  init: init_router,
  local_routes: local_route_map,
};
